
//nav
const nav = document.querySelector('nav');
const el = document.querySelectorAll('details[id^="Details-HeaderMenu-"]');
el.forEach(item => {
  // マウスホバー時の挙動
  item.addEventListener('mouseenter', () => {
    item.setAttribute('open', '');
  });

  item.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
  });
});

//外部リンク
const links = document.querySelectorAll('a');
for (let i = 0; i < links.length; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noopener';
  }
}
